import { combineReducers } from "redux";
import { UserManagerTableDataWidget, AddUserWidget } from "../../../widgets";

export default combineReducers({
    [UserManagerTableDataWidget.reducer_key]:
        UserManagerTableDataWidget.reducer,
    [AddUserWidget.reducer_key]: AddUserWidget.reducer
});
